import React, { useState } from 'react';

function Faq({ className }) {
    const [showQues, setQues] = useState(1);
    const openQuestion = (value) => {
        setQues(value);
    };
    return (
        <>
            <section className={`moelist-faq-area pb-95 ${className || ''}`}>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="moelist-section-title text-center">
                                <h3 className="moelist-title">Frequently asked questions</h3>
                                <p>Frequently asked questions, about the app</p>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-6">
                            <div
                                className="faq-accordion wow fadeInRight mt-30"
                                data-wow-duration="1500ms"
                            >
                                <div
                                    className="accrodion-grp animated fadeIn faq-accrodion wow"
                                    data-wow-duration="1500ms"
                                    data-grp-name="faq-accrodion"
                                >
                                    <div
                                        onClick={() => openQuestion(1)}
                                        className={`accrodion ${showQues === 1 ? 'active' : ''}`}
                                    >
                                        <div className="accrodion-inner">
                                            <div className="accrodion-title">
                                                <h4>Can I watch anime or read manga?</h4>
                                            </div>
                                            <div
                                                className="accrodion-content"
                                                style={{
                                                    display: showQues === 1 ? 'block' : 'none',
                                                }}
                                            >
                                                <div className="inner">
                                                    <p>
                                                        No, you can't read anime or manga, the app
                                                        is just a front end from the
                                                        <a
                                                            rel="noreferrer"
                                                            href="https://myanimelist.net"
                                                            target="_blank"
                                                        >
                                                            MyAnimeList
                                                        </a>
                                                        &#160;website. You can view your watchlist,
                                                        add and edit anime or manga. You can also
                                                        search for anime or manga and view
                                                        information about them.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        onClick={() => openQuestion(2)}
                                        className={`accrodion ${showQues === 2 ? 'active' : ''}`}
                                    >
                                        <div className="accrodion-inner">
                                            <div className="accrodion-title">
                                                <h4>Where can I download the app?</h4>
                                            </div>
                                            <div
                                                className="accrodion-content"
                                                style={{
                                                    display: showQues === 2 ? 'block' : 'none',
                                                }}
                                            >
                                                <div className="inner">
                                                    <p>
                                                        You can currently download the app from
                                                        &#160;
                                                        <a
                                                            rel="noreferrer"
                                                            href="https://play.google.com/store/apps/details?id=com.axiel7.moelist"
                                                            target="_blank"
                                                        >
                                                            Play Store
                                                        </a>
                                                        ,&#160;
                                                        <a
                                                            rel="noreferrer"
                                                            href="https://apt.izzysoft.de/fdroid/index/apk/com.axiel7.moelist"
                                                            target="_blank"
                                                        >
                                                            IzzyOnDroid
                                                        </a>
                                                        ,&#160;
                                                        <a
                                                            rel="noreferrer"
                                                            href="https://github.com/axiel7/MoeList/releases/latest"
                                                            target="_blank"
                                                        >
                                                            Github
                                                        </a>
                                                        .
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div
                                className="faq-accordion wow fadeInRight mt-30"
                                data-wow-duration="1500ms"
                            >
                                <div
                                    className="accrodion-grp animated fadeIn faq-accrodion wow"
                                    data-wow-duration="1500ms"
                                    data-grp-name="faq-accrodion"
                                >
                                    <div
                                        onClick={() => openQuestion(3)}
                                        className={`accrodion ${showQues === 3 ? 'active' : ''}`}
                                    >
                                        <div className="accrodion-inner">
                                            <div className="accrodion-title">
                                                <h4>Is the app available on IOS?</h4>
                                            </div>
                                            <div
                                                className="accrodion-content"
                                                style={{
                                                    display: showQues === 3 ? 'block' : 'none',
                                                }}
                                            >
                                                <div className="inner">
                                                    <p>
                                                        Currently we do not have any plans to
                                                        develop an app on iOS because it would
                                                        require more time to maintain two apps on
                                                        different platforms. MoeList is completely
                                                        free so we hope you understand.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        onClick={() => openQuestion(4)}
                                        className={`accrodion ${showQues === 4 ? 'active' : ''}`}
                                    >
                                        <div className="accrodion-inner">
                                            <div className="accrodion-title">
                                                <h4>I have a question, where can I ask it?</h4>
                                            </div>
                                            <div
                                                className="accrodion-content"
                                                style={{
                                                    display: showQues === 4 ? 'block' : 'none',
                                                }}
                                            >
                                                <div className="inner">
                                                    <p>
                                                        If you have any questions regarding the app,
                                                        please feel free to ask us via
                                                        <a
                                                            rel="noreferrer"
                                                            href="https://discord.gg/CTv3WdfxHh"
                                                            target="_blank"
                                                        >
                                                            Discord
                                                        </a>
                                                        &#160;or via this&#160;
                                                        <a href="mailto://contacto.axiel7@gmail.com">
                                                            E-Mail
                                                        </a>
                                                        .&#160;If you have questions about the
                                                        website, you can ask them at this&#160;
                                                        <a href="mailto://support@lunoxia.de">
                                                            E-Mail
                                                        </a>
                                                        .&#160;
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-12">
                            <div className="faq-text text-center pt-40">
                                <p>
                                    Can't find an answer?{' '}
                                    <a
                                        rel="noreferrer"
                                        href="https://discord.gg/CTv3WdfxHh"
                                        target="_blank"
                                    >
                                        Ask in our Discord
                                    </a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Faq;
